import request from '@/utils/request'
import {
    baseUrl
} from './baseUrl.js'

/**
 * 查询私家团列表（WAP端，仅展示状态为展示的）
 * 复用 PC 后端接口 /privateTour/manage/list
 * @param data
 */
export function akPrivateTourList(data) {
    return request({
        url: baseUrl + '/privateTour/manage/list',
        method: 'post',
        data: {
            ...data,
            showStatus: 1  // 固定只查展示状态的私家团
        }
    })
}

/**
 * 查询私家团详情（WAP端）
 * 复用 PC 后端接口 /privateTour/manage/detail/:id
 * @param data
 */
export function akPrivateTourDetail(data) {
    const id = data.id
    return request({
        url: baseUrl + `/privateTour/manage/detail/${id}`,
        method: 'get'
    })
}

/**
 * 获取私家团报价（WAP端，标准模式）
 * 复用 PC 后端接口 /privateTour/manage/quote
 * @param data
 */
export function akPrivateTourQuote(data) {
    return request({
        url: baseUrl + '/privateTour/manage/quote',
        method: 'post',
        data
    })
}

/**
 * 获取私家团定制模式报价（WAP端）
 * 复用 PC 后端接口 /privateTour/manage/customQuote
 * @param data
 */
export function akPrivateTourCustomQuote(data) {
    return request({
        url: baseUrl + '/privateTour/manage/customQuote',
        method: 'post',
        data
    })
}
